import { AuthInterceptor } from './authInterceptor';
import { AppIdInterceptorProvider } from './appIdentifierInterceptor';

export const interceptorsModule = angular
	.module('phoenix.interceptors',[
		'site.settings'
	])
	.provider('pxAppIdentifierInterceptor', AppIdInterceptorProvider)
	.factory('pxAuthInterceptor', AuthInterceptor);


// WEBPACK FOOTER //
// ./src/phoenix/Interceptors/index.ts